/**
 * This is used to identify the host of an adjustable product like the clothrail.
 * That means this is most likely used to identify the frame that the
 * adjustable product is attached to.
 */
class AdjustableHostComponent {
    constructor() {
        this.typeId = AdjustableHostComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
AdjustableHostComponent.id = 3007;
export default AdjustableHostComponent;
//# sourceMappingURL=AdjustableHostComponent.js.map